import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp, faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { 
  faWrench, faShower, faCog, faSnowflake, 
  faTools, faCircle 
} from '@fortawesome/free-solid-svg-icons';
import { contactInfo } from '../data/businessData';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-dark text-white pt-5 pb-3">
      <Container>
        <Row>
          <Col lg={4} md={6} className="mb-4">
            <h5 className="fw-bold mb-3">
              <img src="/laxmi_logo.png" alt="Laxmi Tyre & Motors" height="30" className="me-2" />
              Laxmi Tyre & Motors
            </h5>
            <p className="text-light mb-3">
              Leading multi-brand automobile service center delivering reliable and professional automotive solutions for over 12 years in Limbodi, Indore.
            </p>
            <div className="d-flex gap-3">
              <a href="https://wa.me/919755265555" className="text-success fs-4" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faWhatsapp} />
              </a>
              <a href="https://www.facebook.com/watch/hashtag/laxmityresandmotors?__eep__=6%2F" className="text-primary fs-4" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faFacebook} />
              </a>
              <a href="https://www.instagram.com/laxmityresmotors/?hl=en" className="text-danger fs-4" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </div>
          </Col>

          <Col lg={2} md={6} className="mb-4">
            <h6 className="fw-bold mb-3">Quick Links</h6>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/" className="text-light text-decoration-none" onClick={scrollToTop}>Home</Link>
              </li>
              <li className="mb-2">
                <Link to="/services" className="text-light text-decoration-none" onClick={scrollToTop}>Services</Link>
              </li>
              <li className="mb-2">
                <Link to="/about" className="text-light text-decoration-none" onClick={scrollToTop}>About Us</Link>
              </li>
              <li className="mb-2">
                <Link to="/our-work" className="text-light text-decoration-none" onClick={scrollToTop}>Our Work</Link>
              </li>
              <li className="mb-2">
                <Link to="/reviews" className="text-light text-decoration-none" onClick={scrollToTop}>Reviews</Link>
              </li>
              <li className="mb-2">
                <Link to="/contact" className="text-light text-decoration-none" onClick={scrollToTop}>Contact</Link>
              </li>
            </ul>
          </Col>

          <Col lg={3} md={6} className="mb-4">
            <h6 className="fw-bold mb-3">Our Services</h6>
            <ul className="list-unstyled">
              <li className="mb-2"><small><FontAwesomeIcon icon={faWrench} className="me-2" />Car Denting & Painting</small></li>
              <li className="mb-2"><small><FontAwesomeIcon icon={faShower} className="me-2" />Car Wash & Detailing</small></li>
              <li className="mb-2"><small><FontAwesomeIcon icon={faCog} className="me-2" />Mechanical Repairs</small></li>
              <li className="mb-2"><small><FontAwesomeIcon icon={faSnowflake} className="me-2" />AC Repair & Service</small></li>
              <li className="mb-2"><small><FontAwesomeIcon icon={faTools} className="me-2" />Regular Maintenance</small></li>
              <li className="mb-2"><small><FontAwesomeIcon icon={faCircle} className="me-2" />Tyre & Wheel Services</small></li>
            </ul>
          </Col>

          <Col lg={3} md={6} className="mb-4">
            <h6 className="fw-bold mb-3">Contact Info</h6>
            <div className="mb-2">
              📍 <small>{contactInfo.address}</small>
            </div>
            <div className="mb-2">
              📞 <small>{contactInfo.phone}</small>
            </div>
            <div className="mb-2">
              ✉️ <small>{contactInfo.email}</small>
            </div>
            <div className="mb-2">
              🕒 <small>{contactInfo.hours}</small>
            </div>
          </Col>
        </Row>

        <hr className="my-4" />

        <Row>
          <Col md={6}>
            <p className="mb-0">© {currentYear} Laxmi Tyre & Motors. All rights reserved.</p>
          </Col>
          <Col md={6} className="text-md-end">
            <p className="mb-0">Made with ❤️ for automobile excellence</p>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col lg={12}>
            <div className="bg-yellow text-dark rounded p-3 text-center">
              <strong>🆘 24/7 Emergency Service: {contactInfo.phone}</strong>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;